import '../index.css';
var styles = {
  "crawler": "bp_loading_indicator_module_crawler--f361e",
  "segment": "bp_loading_indicator_module_segment--f361e",
  "small": "bp_loading_indicator_module_small--f361e",
  "large": "bp_loading_indicator_module_large--f361e",
  "x-large": "bp_loading_indicator_module_x-large--f361e",
  "default": "bp_loading_indicator_module_default--f361e",
  "segment-transform": "bp_loading_indicator_module_segment-transform--f361e",
  "segment-default": "bp_loading_indicator_module_segment-default--f361e",
  "dark": "bp_loading_indicator_module_dark--f361e",
  "segment-dark": "bp_loading_indicator_module_segment-dark--f361e",
  "light": "bp_loading_indicator_module_light--f361e",
  "segment-light": "bp_loading_indicator_module_segment-light--f361e"
};
export { styles as default };